/**
 * Build information utilities
 */

interface BuildInfo {
  year: string;
  buildDate: string;
  appVersion?: string;
  environment: 'production' | 'beta' | 'development';
  timestamp: string;
}

/**
 * Get current build information
 */
function getBuildInfo(): BuildInfo {
  const timestamp = import.meta.env.VITE_BUILD_TIMESTAMP ?? new Date().toISOString();
  const buildDate = new Date(timestamp);
  const year = buildDate.getFullYear().toString();
  const buildDateLabel = buildDate.toISOString().split('T')[0];
  const appVersion =
    typeof import.meta.env.VITE_APP_VERSION === 'string'
      ? import.meta.env.VITE_APP_VERSION
      : undefined;

  const envLabel = (
    import.meta.env.VITE_ENV_LABEL ??
    import.meta.env.VITE_BUILD_TYPE ??
    ''
  ).toLowerCase();

  // Determine environment
  let environment: BuildInfo['environment'] = 'development';

  if (envLabel === 'beta') {
    environment = 'beta';
  } else if (import.meta.env.PROD || envLabel === 'prod' || envLabel === 'production') {
    environment = 'production';
  }

  return {
    year,
    buildDate: buildDateLabel,
    appVersion,
    environment,
    timestamp,
  };
}

/**
 * Format the full version string
 */
export function getVersionString(): string {
  const { buildDate, environment, appVersion } = getBuildInfo();
  const base = 'Luca Milanesi Sistema Tecnico © 2026';

  if (environment === 'production') {
    // Production: show version without build date
    return appVersion ? `${base} · v${appVersion}` : base;
  }

  const envLabel = environment === 'beta' ? 'BETA' : 'DEV';
  const parts = [base];

  if (appVersion) {
    parts.push(`v${appVersion}`);
  }

  parts.push(`Build ${buildDate} (${envLabel})`);
  return parts.join(' · ');
}

export function getBuildTimestamp(): string {
  return getBuildInfo().timestamp;
}

export function isDataResetToolsEnabled(): boolean {
  // Always enable data reset tools in all builds until backend is production-ready
  return true;
}
